






































import Vue from "vue";
export default Vue.extend({
  props: [
    "title",
    "desc",
    "has_back",
    "has_back_handler",
    "has_content_header",
    "no_content_padding",
  ],
  setup(props, { emit, root: { $router } }) {
    const back = () => {
      if (props.has_back_handler) {
        emit("on_back");
      } else {
        $router.back();
      }
    };
    return { back };
  },
});
